// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"26e7632f","952":"39cf96b6"}[chunkId] + ".chunk.js";
};